/*
 * 创建webworker
 */
export function createWorker(f) {
  var blob = new Blob(["\n    self.addEventListener('message', ".concat(f.toString(), ", false);\n    ")]);
  var url = window.URL.createObjectURL(blob);
  var worker = new Worker(url);
  return worker;
}